import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import './services/internationalization/i18n';
import App from './pages/App';
import store from './global/store';
import './index.css';

declare global {
  interface Window {
    appConfig: {
      API: string,
      TKN_KEY: string,
      EMITTER_ID: string,
      USERNAME: string,
      PASSWORD: string,
    };
  }
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store} >
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
